export default __webpack_public_path__ + "static/media/sa3.a6050ca2.jpg";